<aur-mat-table
  class="table-without-header"
  [class.light]="loading()"
  [tableData]="notifications() ?? []"
  [tableConfig]="tableConfig()"
  (rowClick)="openNotificationDetails($event)">
  <ng-template ngxAurCellDef="read" let-notificationWithNew="rowSrc">
    @let notification = asNotification(notificationWithNew);
    <app-icon-button-orange
      icon="fiber_manual_record"
      [disabled]="notification.id === readNotificationId() || loading()"
      [matTooltip]="'action.mark-read' | translate"
      [matTooltipPosition]="'right'"
      [showSpinner]="notification.id === readNotificationId()"
      (action)="readNotification(notification.id, $event)">
    </app-icon-button-orange>
  </ng-template>

  <ng-template ngxAurCellDef="message" let-notificationWithNew="rowSrc">
    @let notification = asNotification(notificationWithNew);
    <span
      class="message-column"
      [matTooltip]="notification.unit.name + ' ' + notification.text + ' '
        + (notification.startTime | utcDateTz: timeZone()) + ' - '
        + (notification.finishTime ? (notification.finishTime | utcDateTz: timeZone()) : '...')"
      matTooltipClass="line-break-tooltip">
      {{ notification.text }}
    </span>
  </ng-template>

  <ng-template ngxAurCellDef="time" let-notificationWithNew="rowSrc">
    <span class="time-column">
      {{ asNotification(notificationWithNew).startTime | utcDateTz: timeZone() : 'HH:mm:ss' }}
    </span>
  </ng-template>
</aur-mat-table>

@if ((notifications()?.length ?? 0) === 0 && !loading()) {
  <div class="warning-message">
    {{ 'message.error.nothing-found' | translate }}
  </div>
}

@if (loading()) {
  <mat-icon class="table-spinner">
    <mat-spinner diameter="50"></mat-spinner>
  </mat-icon>
}
